module.exports = __webpack_public_path__ + "assets/img/banano-logo.c564efd11bcefcf232a852167044cf4d.svg";